export default __webpack_public_path__ + "static/media/img_girl_b.ad4215a1.svg";